import { TakeEffect, takeLatest } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { KEY_POST_ASSIGN_CHECK } from '../constants/keys';
import { API_POST_ASSIGN_CHECK } from '../constants/urls';
import { MOCK_RESPONSE_POST_ASSIGN_CHECK } from '../mocks';

type RequestPostAssignCheck = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY
>['request']['body'];

export type CallParamsPostAssignCheck = RequestPostAssignCheck;

export type CallResponsePostAssignCheck = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY
>['response']['body'];

export type SanityWarning = NonNullable<
  NonNullable<CallResponsePostAssignCheck>['warnings']
>[number];

type CallErrorPostAssignCheck = GenericApiError;

type CallSelectorsPostAssignCheck = {
  warnings: SanityWarning[];
};

export const postAssignCheckCall = createGeneralCall<
  CallParamsPostAssignCheck,
  CallResponsePostAssignCheck,
  CallErrorPostAssignCheck,
  CallSelectorsPostAssignCheck
>({
  id: KEY_POST_ASSIGN_CHECK,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_ASSIGN_CHECK(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_ASSIGN_CHECK : undefined,
  selectors: {
    warnings: ({ selectors }) =>
      createSelector(selectors.response, response => response?.warnings ?? []),
  },
  cancellable: true,
  takeEffect: takeLatest as unknown as TakeEffect,
});
